var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotorhome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 99c-6.617 0-12-5.382-12-12s5.383-12 12-12 12 5.382 12 12-5.383 12-12 12Zm0-18c-3.308 0-6 2.692-6 6s2.692 6 6 6c3.307 0 6-2.692 6-6s-2.693-6-6-6ZM87 99c-6.618 0-12-5.382-12-12s5.382-12 12-12 12 5.382 12 12-5.382 12-12 12Zm0-18c-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6-2.692-6-6-6Z",
    fill: "#222",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.183 90H96v-6h5.183a1 1 0 0 0 1-1V67a.996.996 0 0 0-1-1h-9.978l-9.78-22.818 5.515-2.362 8.22 19.182h6.023a6.95 6.95 0 0 1 4.949 2.05 6.952 6.952 0 0 1 2.051 4.95v16c0 3.86-3.14 7-7 7V90Z",
    fill: "#222",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.892 64.183 67.088 45.97a4.98 4.98 0 0 1 .422-4.722A4.985 4.985 0 0 1 71.685 39h27.028a.97.97 0 0 0 .85-.475.991.991 0 0 0 .144-.663l-3.31-3.367A5.03 5.03 0 0 0 92.832 33H19a1 1 0 0 0-1 1v5h36.182v6H12V34c0-3.86 3.14-7 7-7h73.83c2.93 0 5.79 1.198 7.845 3.29l4.087 4.157.213.423a6.956 6.956 0 0 1-.307 6.81A6.954 6.954 0 0 1 98.712 45h-25.51l7.208 16.818-5.515 2.362-.002.002ZM105.183 69h-9v6h9v-6ZM24 90h-5c-3.86 0-7-3.14-7-7V48h6v35a1 1 0 0 0 1 1h5v6Z",
    fill: "#222",
    className: "fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90V59c0-2.758 2.093-5 4.667-5h11.668c2.573 0 4.668 2.242 4.668 5v31H48Zm6-6h9V60h-9v24Z",
    fill: "#222",
    className: "fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78 84H42v6h36v-6ZM33 69c-4.962 0-9-4.037-9-9 0-4.962 4.038-9 9-9s9 4.038 9 9c0 4.963-4.038 9-9 9Zm0-12c-1.655 0-3 1.345-3 3s1.345 3 3 3 3-1.345 3-3-1.345-3-3-3Z",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorhome);
export default __webpack_public_path__ + "static/media/motorhome.8817fc10.svg";
export { ForwardRef as ReactComponent };